<template>
  <section class="section2">
    <entry-fee-filter />

    <div class="filtersection">
      <div class="user-filter">
        <canvas id="canvasElement" class="canvasElement" height="1"></canvas>
        <canvas id="canvasElement2" class="canvasElement" height="1"></canvas>
        <p ref="better_than">
          {{
            current_standing.better_than === "winner"
              ? translations.you_are_winner
              : translations.better_than_label &&
                translations.better_than_label.replace(
                  /%perc%/,
                  current_standing.better_than
                )
          }}
        </p>

        <div id="sliderWrapper" class="sliderWrapper">
          <div
            class="innerSlider"
            id="innerSlider"
            v-hammer:tap="sliderClick"
            style="pointer-events: none"
          >
            <span
              class="levels level-2 change-top"
              ref="separator_1"
              style="left: calc(83.3333% - 20px)"
            >
              <span>{{ translations.top_1_per }}</span>
            </span>
            <span
              class="levels level-3"
              ref="separator_2"
              style="left: calc(91.6667% - 20px)"
            ></span>
            <span class="levels level-4 change-top" style="left: 100%"></span>
            <div
              class="innerObj"
              id="innerObj"
              v-hammer:pan="onPan"
              v-hammer:panend="onPanEnd"
              style="display: none"
            >
              <element-tag />
              <!-- speech bubble -->

              <div class="bubble-speech" ref="ele_info" style="display: none">
                {{
                  (current_standing.better_than &&
                    translations.speech_bubble[current_standing.better_than]) ||
                  "CONFIDENCE SET TO: BEAT EVERYONE"
                }}
                <svg
                  id="OBJECTS"
                  class="bubble-pointer"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 50 50"
                  ref="bubble_pointer"
                >
                  <path
                    class="cls-1"
                    d="M19.13,7.46C23.29,27.23,1,42.54,1,42.54,36.37,40.31,46.33,19.2,49,7.76Z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style scoped>
.fade-in {
  animation: fadeIn linear 1s;
  opacity: 1;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.fade-out {
  animation: fadeOut linear 0.5s;
  opacity: 0;
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}
</style>
<script>
import Vue from "vue";
import { VueHammer } from "../../../assets/js/vue-hammer";
import { rgbToHex, getClosest, addPagePropertiesToObject, sendTrackingData } from "../../../assets/js/common";
import { CFG_SPEECH_BUBBLE_TM, CFG_TRACKING } from "../../../assets/js/config";
import elementTag from "./Element";
import entryFeeFilter from "./EntryFeeFilter";
Vue.use(VueHammer);
export default {
  name: "RangeSlider",
  components: {
    elementTag,
    "entry-fee-filter": entryFeeFilter,
  },
  computed: {
    translations() {
      return this.$store.state.translations;
    },
    allDataOfTheMatch() {
      return this.$store.state.contest_store.allDataOfTheMatch;
    },
    initialStepValue: {
      get() {
        return this.$store.state.contest_store.initialStepValue;
      },
      set(val) {
        this.$store.state.contest_store.initialStepValue = val;
      },
    },
    element_config() {
      return this.$store.state.contest_store.element_config;
    },
    slicedData() {
      return this.$store.state.contest_store.slicedData;
    },
    slicedData2() {
      return this.$store.state.contest_store.slicedData2;
    },
  },
  data() {
    return {
      lastPosX: 0,
      rightBoxEnd: 0,
      myElement: null,
      sliderElement: null,
      innerSliderBoundingRect: null,
      isDragging: false,
      standings: [],
      can_move_center: true,
      has_moved_to_center: false,
      query_slider_level: null,
      current_standing: {
        better_than: "",
      },
      canvasTimeout: null,
    };
  },
  mounted() {
    this.$parent.$on('cssLoaded', this.initiateCanvas);
    // this.initiateCanvas();
  },
  methods: {
    initiateCanvas() {
      let canvasElement = document.querySelector("#canvasElement");
      let canvasElement2 = document.querySelector("#canvasElement2");
      let canvasParent = document.querySelector(".user-filter");
      this.myElement = document.getElementById("innerObj");
      // this.myElement.style.display = "none";

      this.sliderElement = document.getElementById("innerSlider");
      // this.sliderElement.style = "pointer-events:none;";

      this.innerSliderBoundingRect = this.sliderElement.getBoundingClientRect();
      let ctx = canvasElement.getContext("2d");
      let ctx2 = canvasElement2.getContext("2d");
      let wrapperWidth = canvasParent.offsetWidth;
      canvasElement.width = wrapperWidth;
      canvasElement2.width = wrapperWidth;

      let gradient_bar = new Image();
      let bar = new Image();

      !this.slicedData.length &&
        this.loadImage(gradient_bar, ctx, canvasElement, 1, "gradient_bar.png");

      !this.slicedData2.length &&
        this.loadImage(bar, ctx2, canvasElement2, 2, "bar_2.png");

      this.loadStandings();

      if (this.element_config.apply) {
        this.resetToGivenValue({
          newLeft: this.element_config.newLeft,
          shouldEmit: false,
        });
      } else {
        this.moveSliderTo();
      }
    },
    loadImage(img, ctx, canvasElement, ref, image_name) {
      img.onload = () => {
        ctx.drawImage(img, 0, 0, canvasElement.width, canvasElement.height);
        let imageData = ctx.getImageData(
          0,
          0,
          canvasElement.width,
          canvasElement.height
        );
        this.$store.dispatch("contest_store/updateCanvasData", {
          data: imageData.data,
          type: ref,
        });
      };
      img.onerror = (err) => {
        console.error("error while image loading ", err);
      }
      img.crossOrigin = "Anonymous";
      img.src =  `/static-assets/roi/images/${image_name}`;
    },
    colorObject(newLeft) {
      try {
        let stop_1 = document.getElementById("stop_1");
        let stop_2 = document.getElementById("stop_2");
        let val =
          Math.floor(
            (newLeft / this.rightBoxEnd) * (this.slicedData.length / 4)
          ) - 1;
        let val2 =
          Math.floor(
            (newLeft / this.rightBoxEnd) * (this.slicedData2.length / 4)
          ) - 1;
        val = Math.abs(val);
        val2 = Math.abs(val2);

        let newVal = val * 4;
        let newVal2 = val2 * 4;
        let r = this.slicedData[newVal];
        let g = this.slicedData[newVal + 1];
        let b = this.slicedData[newVal + 2];
        let hashVal = rgbToHex(r, g, b);
        let r2 = this.slicedData2[newVal2];
        let g2 = this.slicedData2[newVal2 + 1];
        let b2 = this.slicedData2[newVal2 + 2];
        let hashVal2 = rgbToHex(r2, g2, b2);
        stop_1.style.stopColor = hashVal;
        stop_2.style.stopColor = hashVal2;
        this.$refs.better_than.style.color = hashVal;
        this.$refs.ele_info.style.color = hashVal;
        this.$refs.ele_info.style.borderColor = hashVal;
        this.$refs.bubble_pointer.style.fill = hashVal;
      } catch (e) {
        console.log(e);
      }
    },
    onPan(ev) {
      this.$refs.ele_info.style.display = "none";
      if (!this.isDragging) {
        this.isDragging = true;
        this.lastPosX = this.myElement.offsetLeft;
      }
      if (ev.isFinal) {
        this.isDragging = false;
      }
      let newLeft = ev.deltaX + this.lastPosX;
      // move our element to that position
      if (newLeft >= 0 && this.rightBoxEnd > newLeft) {
        this.myElement.style.left = newLeft + "px";
        this.colorObject(newLeft);
      }
    },
    checkNewLeft(finalLeft) {
      if (finalLeft < 0) {
        finalLeft = 0;
      }
      if (
        finalLeft >
        this.innerSliderBoundingRect.width - this.myElement.offsetWidth
      ) {
        finalLeft = this.rightBoxEnd;
      }
      return finalLeft;
    },
    onPanEnd(ev) {
      let finalLeft = ev.deltaX + this.lastPosX;
      finalLeft = this.checkNewLeft(finalLeft);
      this.resetToGivenValue({ newLeft: finalLeft });
    },
    sliderClick(ev) {
      let newLeft = ev.center.x - this.innerSliderBoundingRect.left;
      let finalLeft = newLeft - this.myElement.offsetWidth / 2;
      finalLeft = this.checkNewLeft(finalLeft);
      this.resetToGivenValue({ newLeft: finalLeft });
    },
    resetToGivenValue({ newLeft = 0, shouldEmit = true }) {
      this.myElement.style.display = "block";
      this.sliderElement.style = "pointer-events:auto;";

      let found = getClosest(this.standings, "per", newLeft);
      this.myElement.style.left = newLeft + "px";

      this.colorObject(found.per);
      this.current_standing = found;

      if(shouldEmit) {
        this.$store.dispatch("contest_store/rangeChange", {
          stepVal: found.standingp,
          element_config: {
            apply: true,
            newLeft: newLeft,
          },
        });
        let toTrack = CFG_TRACKING["2"];
        toTrack.value = found.standingp;
        toTrack.label = `Difficulty: ${found.standingp}`;
        toTrack = addPagePropertiesToObject(toTrack);
        sendTrackingData(toTrack);
      }

      /**
       * info speech bubble changes
       */
      this.$refs.ele_info.style.display = "block";
      this.$refs.better_than.classList.add("fade-out");
      this.$refs.better_than.classList.remove("fade-in");
      this.$refs.ele_info.classList.remove("right-bubble");

      if (
        document.querySelector(".section2").offsetWidth -
          (newLeft + this.$refs.ele_info.offsetWidth * 0.5) <
        this.$refs.ele_info.offsetWidth
      ) {
        this.$refs.ele_info.classList.add("right-bubble");
      }
      if (this.tm) clearTimeout(this.tm);
      this.tm = setTimeout(() => {
        this.$refs.ele_info.style.display = "none";
        this.$refs.better_than.classList.add("fade-in");
        this.$refs.better_than.classList.remove("fade-out");
      }, CFG_SPEECH_BUBBLE_TM);
    },
    loadStandings() {
      if( this.innerSliderBoundingRect ){
        let isMobile = false;
        typeof window !== "undefined" &&
          (isMobile = window.innerWidth < window.innerHeight);
        this.rightBoxEnd =
          this.innerSliderBoundingRect.width - (isMobile ? 32 : 38);
        this.standings = [...(this.allDataOfTheMatch.standings || [])];
        this.standings = this.standings.reverse();
        let start_point = 50;
        let piece = this.rightBoxEnd / (this.standings.length - 1);
        this.standings.forEach((standing, index) => {
          standing.per = piece * index;
          standing.sp = standing.standingp;
          standing.better_than = start_point + index * 5;
        });
        if (this.standings.length) {
          this.standings.find((e) => e.sp === 3).better_than = 99;
          this.standings.find((e) => e.sp === 2).better_than = 99.9;
          this.standings.find((e) => e.sp === 1).better_than = "winner";
        }
      }
    },
    moveSliderTo({
      canEmit = false,
    } = {}) {
      if (this.element_config.apply || this.has_moved_to_center) return;

      if (
        this.standings.length &&
        this.slicedData.length &&
        this.slicedData2.length &&
        this.innerSliderBoundingRect
      ) {
        this.$refs.separator_1.style.display = "block";
        this.$refs.separator_2.style.display = "block";
        this.$refs.separator_1.style.left = `calc(${
          (100 / (this.standings.length - 1)) * (this.standings.length - 3)
        }% - 20px)`;
        this.$refs.separator_2.style.left = `calc(${
          (100 / (this.standings.length - 1)) * (this.standings.length - 2)
        }% - 20px)`;

        /**to move slider */
        let spts = this.standings.map((e) => e.sp);
        let center_val = spts[Math.round((spts.length - 1) / 2)];
        let newLeft = this.innerSliderBoundingRect.width / 2 - 20;
        let to_move = this.standings.find(
          (e) => +e.sp === +this.initialStepValue
        );

        if (!to_move) {
          this.initialStepValue = center_val;
          canEmit = true;
        }
        if (+center_val !== +this.initialStepValue && to_move) {
          newLeft = to_move.per;
        }
        this.has_moved_to_center = true;
        this.resetToGivenValue({
          newLeft,
          shouldEmit: canEmit,
        });
      }
    },
  },
  watch: {
    /**
     * when all contests are loaded
     * get standings
     */
    allDataOfTheMatch: function () {
      this.loadStandings();
      this.moveSliderTo();
    },
    /**
     * for image data point to load
     */
    slicedData: function () {
      this.moveSliderTo();
    },
    slicedData2: function () {
      this.moveSliderTo();
    },
  },
  beforeDestroy() {
    if (this.tm) clearTimeout(this.tm);
  },
};
</script>
